"use client";

import { RenewalPage } from "@/config/app-constant";

import ActionButton from "../../action-button/action-button";

type FooterProps = {
  footerContinueCta: string;
  onClickContinue?: () => void;
  onClickBack?: () => void;
  disableMain?: boolean;
};

export function FooterRenewal({
  footerContinueCta,
  onClickBack,
  onClickContinue,
  disableMain = false,
}: Readonly<FooterProps>) {
  return (
    <div className=" lg:mt-spacing-xxl lg:pb-spacing-6xl lg:max-w-[414px] mx-auto mt-0 max-w-[unset] w-full fixed z-[1] bottom-0 left-0 lg:relative flex flex-col justify-between h-fit">
      <div className=" backdrop-blur-[1.5px] bg-interactive-overlay-image lg:hidden absolute h-full w-full z-[1] top-0 right-0" />
      <div className="py-spacing-s lg:!p-0 md:w-[414px] mx-auto">
        <ActionButton
          page={RenewalPage}
          showBackBtn
          submitButtonClick={() => onClickContinue && onClickContinue()}
          backButtonClick={() => onClickBack && onClickBack()}
          ctaButtonText={footerContinueCta}
          disableMain={disableMain}
        />
      </div>
    </div>
  );
}
